import React from "react";
import Loadinguser from "../../../components/Loadingnovel";

function Skeleton() {
  return (
    <div>
      <div className="bg-tertiary p-8 md:p-10 mt-[70px] h-fit ">
        <div className="relative h-full flex flex-col justify-between ">
          <div className=" gap-y-6 flex flex-col">
            <div className=" flex-nowrap w-full flex justify-start items-center gap-x-4">
              <div
                title="Profile"
                className="flex-none h-[50px] w-[50px] border-tertiary border-2 rounded-full ml-10 z-30 relative"
              >
                <div className="flex justify-center items-center h-full w-full rounded-full opacity-20 scale-90 rectangle duration-[0] ease-in-out object-cover">
                  <Loadinguser />
                </div>
              </div>
              <div
                title="Novel"
                className="z-20 h-[60px] border-primary border-2 rounded-full w-[60px] absolute top-1/2 -translate-y-1/2 left-0"
              >
                <div className="flex justify-center items-center h-full w-full rounded-full opacity-20 scale-90 rectangle duration-[0] ease-in-out object-cover">
                  <Loadinguser />
                </div>
                <div className="-z-10 absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2">
                  <div className="bg-primary rounded-full z-10 h-[45px] w-[45px] animate-ping "></div>
                </div>
              </div>
              <div className="z-50 flex-1  w-full flex relative flex-col text-[14px] sm:text-[16px] ">
                <h2 className="text-secondary capitalize font-SoraS">
                  EyeNovel
                </h2>
                <div className="w-fit">
                  <p className="text-primary linebutton line-clamp-1 capitalize pb-1 leading-6 sm:leading-4 cursor-pointer font-SoraR relative duration-500 ease-in-out">
                    EyeNovel EyeNovel
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="z-30 mt-6 sm:mt-6">
            <div className="mt-2 w-full">
              <p className="text-secondary line-clamp-[12] break-words font-SoraR text-[14px] md:text-[16px]">
                EyeNovel | Read Free Online Novels In Your Favor & EyeNovel |
                Read Free Online Novels In Your Favor & EyeNovel | Read Free
                Online Novels In Your Favor & EyeNovel | Read Free Online Novels
                In Your Favor & EyeNovel | Read Free Online Novels In Your Favor
                & EyeNovel | Read Free Online Novels In Your Favor & EyeNovel |
                Read Free Online Novels In Your Favor & EyeNovel | Read Free
                Online Novels In Your Favor & EyeNovel | Read Free Online Novels
                In Your Favor
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Skeleton;
